<template>
  <bc-modal
    v-model="menu"
    ref="menu"
    variant="menu"
  >
  <div class="bg-primary-700 text-white flex flex-col min-h-full">
    <slinky @close="$refs.menu.hide()" :nodes="nodes"></slinky>
      <slot />
    </div>
  </bc-modal>
</template>
<script>
export default {
  name: 'AppMobileMenu',
  props: {
    nodes: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  computed: {
    menu: {
      get () {
        return this.$store.state.menu.open
      },
      set (val) {
        this.$store.commit('menu/TOGGLE', val)
      }
    }

  },
  /*
  watch: {
    menu(v) {
      v === true
      ? this.$locomotive.stop()
      : this.$locomotive.start()
    }
  }*/
}
</script>
